import React from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';
import { EVENT_NAME, PAGE_NAMES } from 'appenv';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Routes from 'Routes';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import { selectAllWebinars } from 'models/webinars';
import { useSelector } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';

const RootContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  color: #484848;
  overflow: auto;
  text-align: justify;
`;

const DetailContainer = styled.div`
  margin-left: 0;
  margin-right: 0;
  padding: 0 5vw;

  & > * {
    margin-bottom: 20px;
  }

  & a {
    color: #5C8DF3;
    text-decoration: none;
  }

  @media only screen and (min-width: 960px) {
    margin-left: 20vw;
    margin-right: 20vw;
    padding: 0;
  }
`;

const BreadcrumbsContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 24px;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
`;

const OverflowContainer = styled.div`
  overflow: auto;
`;

const AboutPage = () => {
  const webinars = useSelector(selectAllWebinars);
  const about = webinars.find((it) => it?.translations?.en?.title?.toLowerCase() === 'about');
  const text = about?.translations?.en?.description || '';

  return (
    <RootContainer>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`About | ${EVENT_NAME}`}</title>
        <meta name="description" content={`About page of ${EVENT_NAME}.`} />
      </Helmet>
      <OverflowContainer>
        <BreadcrumbsContainer>
          <Breadcrumbs aria-label="breadcrumb" separator=">">
            <StyledLink to={Routes.lobby}>
              {PAGE_NAMES.lobby}
            </StyledLink>
            <Typography color="textPrimary">
              About
            </Typography>
          </Breadcrumbs>
        </BreadcrumbsContainer>
        <DetailContainer>
          {ReactHtmlParser(text)}
        </DetailContainer>
      </OverflowContainer>
    </RootContainer>
  );
};

export default AboutPage;
